import React, { useState } from 'react';
import SlideMenu from '../components/SlideMenu';

const PreviewSlideMenu = () => {
  const [open, setOpen] = useState(true);
  const mockUser = {
    id: 'preview-user',
    name: 'Marco Preview',
    email: 'marco@example.com',
    picture: null
  };

  return (
    <div className="min-h-screen bg-[#FAFAF9] p-6">
      <SlideMenu isOpen={open} onClose={() => setOpen(false)} user={mockUser} onLogout={() => alert('logout (preview)')} />
    </div>
  );
};

export default PreviewSlideMenu;
